// libs
import { styled } from '@nykaa/ui-components';

// components
import BaseOverlaySheet from 'shared/components/OverlaySheet';

export const IFrame = styled.iframe<{ visibility: boolean }>`
  height: 100%;
  width: 100%;
  visibility: ${(props) => props.visibility && 'hidden'};
  border: 0;
  display: block;
`;

export const DwebOverlaySheet = styled(BaseOverlaySheet)`
  background-color: #fff;
  height: 100%;
  width: 30%;
  background-color: #fff;
  left: initial;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const CloseIconWrapper = styled.span`
  position: absolute;
  top: 10px;
  left: 10px;
  cursor: pointer;
`;
